import { BrickInfo } from "../BrickInfoTotal/BrickInfo";
import { BrickInfoTotal } from "../BrickInfoTotal/BrickInfoTotal";

export interface BrickInventoryEntry extends BrickInfo {
  amount: number;
  capacity: number;
  autoCollect: number;
  userHidden: boolean;
}

export const loadBrickInventory = () => {
  let BrickInventory: Map<string, BrickInventoryEntry> = new Map<
    string,
    BrickInventoryEntry
  >([]);

  BrickInfoTotal.forEach((brickInfo, brickId) => {
    BrickInventory.set(brickId, {
      id: brickId,
      name: brickInfo.name,
      fullName: brickInfo.fullName,
      type: brickInfo.type,
      viaPack: brickInfo.viaPack,
      viaSplit: brickInfo.viaSplit,
      //
      // TODO: Values are updated with data present in JSON save
      // Leaving as default values for now
      //
      amount: NaN,
      capacity: 30,
      autoCollect: 0,
      userHidden: false,
    });
  });

  return BrickInventory;
};
